import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { saveSid, handleChangeCerts } from '../../SidCertsHandler'
import * as Constants from '../../../../config/Constants'
import * as Utility from '../../Utility'
import * as actions from '../../../../actions/index'
import getText from '../../../shared/i18n/labels'

// MODAL
import ModalPasswordBits from './ModalPasswordBits'
import { ModalPecParameters } from './ModalPecParameters'
import { Col, Modal } from 'react-bootstrap'

// FORM
import { BwmInput } from '../BwmInputB5'

// COMPONENTS
import { StarTooltip } from '../../tooltips/Tooltip'
import { PageSpinner } from '../../spinner/PageSpinner'
import { LicenseExpiredPopup } from '../../auth/license/LicenseExpiredPopup'
import { PopupError } from '../../popups/PopupError'
import { PopupConfirm, titleColors } from '../../popups/PopupConfirm'

/**
 * SidForm è un componente React che gestisce la visualizzazione e la funzionalità relative ai certificati SID.
 * Gestisce il caricamento, la verifica e la gestione dei dati dei certificati attraverso vari modali.
 * Il componente utilizza i React hook per gestire lo stato e interagisce con diverse azioni Redux e funzioni di utilità.
 *
 * @param {Object} coraSubjectSid - Contiene dati relativi al SID come sidNumber, password e certificati.
 * @param {string} nameApplication - Il nome dell'applicazione.
 * @param {string} fiscalCode - Il codice fiscale richiesto per la gestione dei certificati.
 * @param {boolean} disabled - Flag che indica se il soggetto è disabilitato
 * @param {boolean} archived - Flag che indica se il soggetto è archiviato
 * @param {Object} errors - Contiene informazioni sugli errori per i campi.
 * @param {function} handleChangeSid - Funzione per gestire i cambiamenti nei valori del SID.
 * @param {function} handleChangeSidValues - Funzione per aggiornare i valori del campo sid.
 * @param {function} setIsCertSidOpened - Funzione per impostare lo stato se un SID è aperto.
 * @param {function} saveSubject - Funzione per salvare i dati del soggetto.
 * @param {function} setCertificateFiles - Funzione per impostare i file per i certificati.
 * @param {function} checkSid - Funzione per controllare la validità del SID.
 */

function SidForm(props) {
  const lang = useSelector((state) => state.language.language)
  const labels = getText(lang)

  const [isPecModalOpen, setPecModalOpen] = useState(false)
  const [openModalPasswordBits, setOpenModalPasswordBits] = useState(false) //sola verifica
  const [openModalLoadCertificates, setOpenModalLoadCertificates] = useState(false) //verifica e caricamento
  const [openModalVerifyCertificates, setOpenModalVerifyCertificates] = useState(false)
  const [loading, setLoading] = useState('')
  const [certificateDto, setCertificateDto] = useState()
  const [signatureCertificateDto, setSignatureCertificateDto] = useState()
  const [type, setType] = useState('password')

  const nameApplication = props.nameApplication

  const [certificate1, setCertificate1] = useState()
  const [certificate2, setCertificate2] = useState()
  const [certificate3, setCertificate3] = useState()
  const [modalSidPassword, setModalSidPassword] = useState() //password inserita nel modale di inserimento certificati

  useEffect(() => {
    if (openModalVerifyCertificates == false) {
      setCertificate1()
      setCertificate2()
      setCertificate3()
      setModalSidPassword()
    }
  }, [openModalVerifyCertificates])

  useEffect(() => {
    if (openModalLoadCertificates) {
      setModalSidPassword(props.coraSubjectSid?.password)
    }
  }, [openModalLoadCertificates])

  /**
   * Questa funzione serve per capire se attivare il pulsante VERIFICA.
   */
  //condizioni per abilitare il pulsante:
  //- i certificati devono essere stati caricati
  //- il codice fiscale, numero sid e password devono essere valorizzati
  //- la licenza deve essere valida
  const shouldEnableVerifyButton =
    Utility.isNotEmpty(props.coraSubjectSid?.sidNumber) &&
    Utility.isNotEmpty(props.coraSubjectSid?.password) &&
    Utility.isNotEmpty(props.fiscalCode) &&
    !props.disabled &&
    props.coraSubjectSid?.certificate1 &&
    props.coraSubjectSid?.certificate2

  /**
   * Questa funzione serve per capire se attivare il pulsante CARICA.
   */
  //condizioni per abilitare il pulsante:
  //- il codice fiscale, numero sid e password devono essere valorizzati
  const shouldEnableLoadButton =
    Utility.isNotEmpty(props.coraSubjectSid?.sidNumber) && Utility.isNotEmpty(props.fiscalCode)

  useEffect(() => {
    props.setIsCertSidOpened(!!props.coraSubjectSid?.sidNumber)
  }, [])

  useEffect(() => {
    props.setIsCertSidOpened(!!props.coraSubjectSid?.sidNumber)
  }, [props.coraSubjectSid?.sidNumber])

  /**
   * Gestisce il click sul pulsante occhio della password.
   *
   * Alterna il tipo del campo password tra 'password' e 'text'.
   */
  const onClickIconPsw = (e, elementId) => {
    let x = document.getElementById(elementId)
    if (x !== null) {
      if (x.type === 'password') {
        setType('text')
        x.type = 'text'
      } else {
        setType('password')
        x.type = 'password'
      }
    }
  }

  /**
   * verifica, i certificati caricati contro la password fornita nel form
   * se il SID non è ancora stato salvato, viene passato anche il file  UTEC.P12 per la verifica
   * se il SID è già stato salvato, lo aggiorna con i nuovi dati(bits, date di scadenza/emissione)
   */
  const verifySidCertificate = async () => {
    const id = props.coraSubjectSid?.id
    const password = props.coraSubjectSid?.password
    const files = props.certificateFiles
    const response = await props.checkSid(props.coraSubjectSid.sidNumber)
    if (!response) return
    if (Utility.isNotEmpty(id)) {
      actions
        .postSendFileToVerifySidCertificateById(nameApplication, id, password, props.fiscalCode)
        .then(
          (answer) => onCorrectRequest(answer),
          (err) => errRequest(err)
        )
    } else if (files.length > 0 && files.length < 4) {
      actions
        .postSendFileToVerifySidCertificate(nameApplication, files, password, props.fiscalCode)
        .then(
          (answer) => {
            onCorrectRequest(answer)
          },
          (err) => errRequest(err)
        )
    }
  }

  //1) effettua la verifica con popup.
  //negativa: popup di errore e mantieni aperta modale
  //positiva: modale dati certificato e chiudi modaledi inserimento
  //2) al salva: carica certificati storici(se presenti), poi salva nuovi certificati
  const onAcceptCertificateModal = async (
    certificate1,
    certificate2,
    certificate3,
    newPassword
  ) => {
    const files = [certificate1, certificate2, certificate3]
    const response = await props.checkSid(props.coraSubjectSid.sidNumber)
    if (!response) return
    setLoading(true)
    actions
      .postSendFileToVerifySidCertificate(nameApplication, files, newPassword, props.fiscalCode)
      .then(
        (res) => {
          //salvo i cert storici
          //se il corasubjectSid ha un id, verifico se il certificato caricato sia scaduto
          //se sì, lo carico nello storico
          //se no, lo salvo
          const checkCertificate = !(
            Utility.isEmpty(props.coraSubjectSid.certificate1) ||
            props.coraSubjectSid.certificate1 === 'UTEC.P12'
          )
          const certificateDto = res[0]
          const isNotValid = new Date(certificateDto.endDate) < new Date()
          if (props.coraSubjectSid.id && isNotValid && checkCertificate) {
            setLoading(true)
            actions
              .loadExpiredCertificate(
                props.coraSubjectSid.sidNumber,
                nameApplication,
                modalSidPassword,
                files,
                certificateDto
              )
              .then(
                (res) => {
                  setOpenModalLoadCertificates(false)
                  PopupConfirm({
                    title: labels.CERTIFICATES_UPLOADED_SUCCESSFULLY,
                    titleColor: titleColors.SUCCESS,
                    showCancelButton: false,
                    component: () => (
                      <div>
                        {labels.CERTIFICATES_JUST_UPLOADED_HAVE_EXPIRED} (
                        {Utility.formatDateForDisplay(certificateDto.endDate)})<br />
                        {labels.CERTIFICATES_JUST_UPLOADED_HAVE_EXPIRED_TEXT}
                        <br />
                        {labels.CERTIFICATES_JUST_UPLOADED_HAVE_EXPIRED_TEXT_2}
                        <br />
                      </div>
                    )
                  })
                },
                (err) => PopupError({ text: err.title ? err.title : labels.GENERIC_ERROR })
              )
              .then(() => setLoading(false))
          }
          if (isNotValid) {
            PopupError({
              text: `${labels.CERTIFICATES_JUST_UPLOADED_HAVE_EXPIRED}(${Utility.formatDateForDisplay(certificateDto.endDate)})`
            })
          } else {
            res.forEach((element) => {
              if (element.certificateType === 'CERTIFICATO') {
                setCertificateDto(element)
              } else if (element.certificateType === 'FIRMA') {
                setSignatureCertificateDto(element)
              }
            })
            setOpenModalLoadCertificates(false)
            setOpenModalVerifyCertificates(true) //apro modale di conferma
          }
        },
        (err) => errRequest(err)
      )
      .then(() => setLoading(false))
  }

  /**
   * alla chiusura, deve salvare i dati prima del certificato storico (se necessario), poi dei nuovi certificati
   */
  const onSaveModalVerifyCertificates = () => {
    const files = [certificate1, certificate2, certificate3]
    props.setCertificateFiles(files)
    const _coraSubjectSid = {
      ...props.coraSubjectSid,
      encryptionBits: certificateDto.econdingBits || null,
      endDate: certificateDto.endDate ? new Date(certificateDto.endDate) : null,
      expirationDate: certificateDto.endDate ? new Date(certificateDto.endDate) : null,
      startDate: certificateDto.startDate ? new Date(certificateDto.startDate) : null,
      password: modalSidPassword,
      certificate1: certificate1,
      certificate2: certificate2,
      certificate3: certificate3
    }
    props.handleChangeSidValues(_coraSubjectSid)
    handleChangeCerts(
      files,
      (value) => props.setErrorCertificates(value),
      _coraSubjectSid,
      props.subject?.coraSubjectSid,
      props.defaultEmail,
      (coraSubjectSid) => {
        {
          setOpenModalVerifyCertificates(false)
          props.saveSubject(coraSubjectSid, files)
        }
      },
      labels
    )
  }

  /**
   *
   * Scarica i certificati associati alla proprietà coraSubjectSid.
   * Verifica prima se esiste il coraSubjectSid id, poi chiama
   * l'azione exportCertificateFiles per scaricare i certificati.
   * Se la chiamata ha successo, scarica i certificati in un file zip e mostra un messaggio di successo.
   * Altrimenti, mostra un popup di errore.
   *
   */
  const onClickExportCertificateFiles = async () => {
    const id = props.coraSubjectSid?.id
    if (!id) {
      return
    }
    const response = await props.checkSid(props.coraSubjectSid.sidNumber)
    if (!response) return
    actions
      .exportCertificateFiles(id)
      .then(
        (res) => {
          if (res) {
            Utility.downloadFile(res.data, 'certificati.zip')
            Utility.notifySuccess(labels.CERTIFICATES_DOWNLOADED)
          }
        },
        (err) => PopupError({ text: labels.GENERIC_ERROR })
      )
      .then(() => setLoading(false))
  }

  /**
   * Questa funzione aggiorna il sid con i dati appena ottenuti dalla verifica dei certificati
   * @param {array} answer la risposta data dalla chiamata rest
   */
  const onCorrectRequest = (answer) => {
    let _coraSubjectSid = {}
    answer.forEach((element) => {
      if (element.certificateType === 'CERTIFICATO') {
        setCertificateDto(element)
        _coraSubjectSid = {
          ...props.coraSubjectSid,
          encryptionBits: element.econdingBits || null,
          endDate: element.endDate ? new Date(element.endDate) : null,
          expirationDate: element.endDate ? new Date(element.endDate) : null,
          startDate: element.startDate ? new Date(element.startDate) : null
        }
        props.handleChangeSidValues(_coraSubjectSid)
      } else if (element.certificateType === 'FIRMA') {
        setSignatureCertificateDto(element)
      }
    })
    setOpenModalPasswordBits(true)
    return _coraSubjectSid
  }

  /**
   * Questa funzione deve ritornare un popup e nel farlo deve capire che errore dare
   * Essendo che non c'è la certezza che title abbia un valore si fa questo controllo e
   * e si mette un valore piu generico casomai non c'è niente di piu descrittivo dal
   * backend
   * @param {*} err L'errore dato nel fare la chiamata REST
   */
  const errRequest = (err) => {
    if (err?.title) {
      if (err.errorKey === 'InvalidLicense') {
        LicenseExpiredPopup()
      } else {
        PopupError({ text: err.title })
      }
    } else {
      PopupError({ text: labels.GENERIC_ERROR })
    }
  }

  const datesText =
    props.coraSubjectSid?.startDate &&
    props.coraSubjectSid?.expirationDate &&
    `${new Date(props.coraSubjectSid?.startDate).toLocaleDateString()} - ${new Date(props.coraSubjectSid?.expirationDate).toLocaleDateString()}`

  /**
   * Questa funzione viene chiamata quando si vuole chiudere la modale.
   * Se il sid ha un id, allora salva il sid con la funzione saveSid,
   * altrimenti semplicemente chiude la modale
   */
  const hideModal = () => {
    if (props.coraSubjectSid.id) {
      saveSid(
        props.certificateFiles,
        props.coraSubjectSid,
        props.coraSubjectSid.fiscalCode,
        props.coraSubjectSid.application,
        () => props.saveSubject(props.coraSubjectSid),
        () => PopupError(),
        () => setOpenModalPasswordBits(false)
      )
    } else {
      setOpenModalPasswordBits(false)
    }
  }

  /**
   * Funzione per chiudere la modale di configurazione dei parametri PEC
   */
  const closePecModal = () => {
    setPecModalOpen(false)
  }

  /**
   * Funzione per salvare i parametri PEC del soggetto.
   * Aggiorna il nuovo sid nel componente padre tramite handleChangeSidValues
   * Se il sid ha un id, allora salva il sid con la funzione saveSid
   * altrimenti semplicemente chiude la modale dei parametri PEC.
   *
   */
  const onSaveMailParameters = (subjectSid) => {
    props.handleChangeSidValues(subjectSid)

    if (Utility.isNotEmpty(subjectSid?.id)) {
      saveSid(
        props.certificateFiles,
        subjectSid,
        subjectSid.fiscalCode,
        subjectSid.application,
        () => {
          closePecModal()
        },
        (errors) => PopupError({ text: errors.detail ? errors.detail : labels.GENERIC_ERROR })
      )
    } else {
      closePecModal()
    }
  }

  /**
   * Apre una finestra di dialogo per la gestione automatica della PEC.
   * Prima, verifica il SID utilizzando il numero di SID fornito.
   * Se il SID  valido e ha un ID vuoto, mostra una finestra di conferma.
   * Altrimenti, apre la modale dei parametri PEC.
   */
  const onClickOpenDialogAutomaticPecManagment = async () => {
    const response = await props.checkSid(props.coraSubjectSid?.sidNumber)
    if (!response) return
    if (Utility.isEmpty(props.coraSubjectSid?.id)) {
      PopupConfirm({
        titleColor: titleColors.ALERT,
        text: labels.SET_PEC_PARAMETERS_DESCRIPTION_2,
        showCancelButton: false
      })
    } else {
      setPecModalOpen(true)
    }
  }

  /**
   * Modale per verificare la validità dei certificati.
   * La modale sarà centrata e avrà un titolo di "Verifica certificati".
   * La modale avrà un pulsante di chiusura e un pulsante "Chiudi e salva".
   * Il pulsante "Chiudi e salva" chiama la funzione onConfirm quando cliccato.
   *
   * @param {boolean} isOpen - Se la modale è aperta o no.
   * @param {function} onClose - Una funzione che chiude la modale.
   * @param {function} onConfirm - Una funzione che verifica i certificati e chiude la modale.
   */
  const renderModalPasswordBits = (isOpen, onClose = () => {}, onConfirm = () => {}) => {
    return (
      <Modal
        show={isOpen}
        centered
        aria-labelledby="contained-modal-title-vcenter"
        onHide={onClose}
        size="lg">
        <div className="bar"></div>
        <Modal.Header closeButton>
          <Modal.Title>{labels.VERIFY_CERTIFICATES}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ paddingLeft: '27px', paddingTop: '70px' }}>
          <div className="d-flex">
            <Col>
              <ModalPasswordBits certificateDto={certificateDto} fiscalCode={props.fiscalCode} />
            </Col>

            <Col>
              <ModalPasswordBits
                certificateDto={signatureCertificateDto}
                fiscalCode={props.fiscalCode}
              />
            </Col>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-end">
          <button className="btn btn-primary " onClick={onConfirm}>
            {labels.CLOSE_AND_SAVE}
          </button>
        </Modal.Footer>
      </Modal>
    )
  }

  return (
    <div className="">
      {loading && <PageSpinner />}
      <div className="d-flex  mb-2">
        <div>
          {/* Pulsante che apre la modale per la gestione automatica della PEC */}
          {/* Se lo schermo è troppo piccolo mostra solo l'icona */}
          <StarTooltip
            text={
              window.innerWidth <= Constants.BREAKPOINT_LG && labels.SET_UP_AUTOMATIC_PEC_MANAGEMENT
            }>
            <button
              disabled={props.disabled}
              className={`btn btn-primary`}
              onClick={() => onClickOpenDialogAutomaticPecManagment()}>
              {window.innerWidth < Constants.BREAKPOINT_LG ||
              (Utility.isFontBigger() && window.innerWidth < 1650) ? (
                <i className="star-icon-settings star-icon" />
              ) : (
                labels.SET_UP_AUTOMATIC_PEC_MANAGEMENT
              )}
            </button>
          </StarTooltip>
        </div>
        <div className="col d-flex justify-content-end align-self-center">
          <span className="image-upload">
            <label htmlFor={`certificateFiles${props.id || 0}`}>
              {/* Pulsante per CARICARE i certificati */}
              <StarTooltip
                text={!shouldEnableLoadButton && labels.SET_PEC_PARAMETERS_DESCRIPTION_3}>
                <div
                  disabled={props.disabled || props.archived || !shouldEnableLoadButton}
                  title={labels.LOAD_CERTIFICATES}
                  onClick={() => setOpenModalLoadCertificates(true)}
                  className={`btn btn-outline-primary text-small ${!shouldEnableLoadButton || props.disabled || props.archived ? 'disabled' : ''}`}>
                  <i className="star-icon-upload star-icon me-2" />
                  {labels.LOAD}
                </div>
              </StarTooltip>
            </label>
          </span>

          <StarTooltip text={!shouldEnableVerifyButton && labels.SET_PEC_PARAMETERS_DESCRIPTION_4}>
            {/* Pulsante per VERIFICARE i certificati */}
            <button
              title={labels.VERIFY_CERTIFICATES}
              disabled={!shouldEnableVerifyButton || props.disabled || props.archived}
              className="btn btn-outline-primary me-2 ms-2 text-small"
              onClick={() => verifySidCertificate()}>
              <i className="star-icon-check star-icon me-2" />
              {labels.VERIFY}
            </button>
          </StarTooltip>
          {/* Pulsante per ESPORTARE i certificati (esegue il download) */}
          <button
            className="btn btn-outline-primary text-small"
            title={labels.EXPORT_CERTIFICATES}
            disabled={!(props.coraSubjectSid?.id && shouldEnableVerifyButton) || props.disabled}
            onClick={() => onClickExportCertificateFiles()}>
            <i className="star-icon-export star-icon me-2 mt-1" />
            {labels.EXPORT}
          </button>
        </div>
      </div>
      {/* Se sono presenti errori nei certificati vengono stampati gli errori */}
      {props.errors?.errorCertificates && !props.errors.errorCertificates.isValid && (
        <div className="row align-items-center justify-content-end text-danger me-2">
          <strong>{props.errors.errorCertificates.msg}</strong>
        </div>
      )}
      <div className="row mt-2 align-items-center">
        <div className={`${props.sizes.sidNumber} d-flex pe-2 mb-2`}>
          {/* Numero SID */}
          <BwmInput
            disabled={props.disabled || props.archived}
            className={'form-control'}
            maxLength={8}
            label={`${labels.SID_NUMBER}`}
            autoComplete="new-password"
            autocorrect="off"
            name="sidNumber"
            value={props.coraSubjectSid?.sidNumber}
            error={props.errors?.errorSidNumber?.msg}
            touched={props.errors?.errorSidNumber?.isValid === false}
            onChange={(e) => props.handleChangeSid(e, 'errorSidNumber', labels.REQUIRED_FIELD)}
          />
        </div>
        <div className={`${props.sizes.password} pe-2 mb-2`}>
          <div className="d-flex">
            {/* Password */}
            <BwmInput
              disabled={props.disabled || props.archived}
              id={`password${props.id || 0}`}
              type={'password'}
              autoComplete="new-password"
              autocorrect="off"
              className={'form-control'}
              label={
                window > Constants.BREAKPOINT_MD
                  ? `${labels.PASSWORD_PROTECTION}`
                  : `${labels.PASSWORD}`
              }
              placeholder={labels.MAX_20_CHARACTERS}
              maxLength={20}
              name="password"
              value={props.coraSubjectSid?.password}
              error={props.errors?.errorPassword?.msg}
              touched={props.errors?.errorPassword?.isValid === false}
              onChange={(e) => props.handleChangeSid(e, 'errorPassword', labels.REQUIRED_FIELD)}
              Icon={() => (
                <div
                  className={`d-flex align-self-center ${props.errors?.errorPassword?.isValid === false ? 'me-4' : ''}`}
                  onClick={(e) => onClickIconPsw(e, `password${props.id || 0}`)}>
                  <i
                    className={`star-icon bg-primary ${type === 'text' ? 'star-icon-eye' : 'star-icon-eye-off'}`}
                  />
                </div>
              )}
            />
          </div>
        </div>
        <div className={`${props.sizes.expirationDate} mb-2`}>
          <StarTooltip text={datesText}>
            <div>
              {/* Periodo di validita dei certificati */}
              <BwmInput
                disabled
                label={`${labels.VALIDITY_CERTIFICATES}`}
                className={'form-control'}
                name="expirationDate"
                value={datesText}
              />
            </div>
          </StarTooltip>
        </div>
        {/**modale per la SOLA verifica */}
        {openModalPasswordBits &&
          renderModalPasswordBits(
            openModalPasswordBits,
            () => {
              setOpenModalLoadCertificates(false)
              setOpenModalPasswordBits(false)
            },
            hideModal
          )}

        {/**modale per il CARICAMENTO dei certificati */}
        {openModalVerifyCertificates &&
          renderModalPasswordBits(
            openModalVerifyCertificates,
            () => {
              setOpenModalLoadCertificates(false)
              setOpenModalVerifyCertificates(false)
            },
            onSaveModalVerifyCertificates
          )}

        {openModalLoadCertificates && (
          /**modale per il CARICAMENTO dei certificati */
          <Modal
            show={openModalLoadCertificates}
            centered
            aria-labelledby="contained-modal-title-vcenter"
            onHide={() => setOpenModalLoadCertificates(false)}
            size="lg">
            <div className="bar"></div>
            <Modal.Header closeButton>
              <Modal.Title>{labels.LOAD_CERTIFICATES}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ paddingLeft: '27px', paddingTop: '70px' }}>
              <div className="d-flex justify-content-center">
                {/* Drag and drop dove è possibile inserire il file UTEC.P12 da caricare */}
                <DragNDropInputBox
                  fileName={'UTEC.P12'}
                  isValid={(file) => file?.name === 'UTEC.P12'}
                  onFileLoaded={(file) => setCertificate1(file)}
                  loadedFile={certificate1}
                />
                <div className="ms-4 me-4">
                  {/* Drag and drop dove è possibile inserire il file UTEF.P12 da caricare */}
                  <DragNDropInputBox
                    fileName={'UTEF.P12'}
                    isValid={(file) => file?.name === 'UTEF.P12'}
                    onFileLoaded={(file) => setCertificate2(file)}
                    loadedFile={certificate2}
                  />
                </div>
                {/* Drag and drop dove è possibile inserire il file UTENTE.KS da caricare */}
                <DragNDropInputBox
                  fileName={'UTENTE.KS'}
                  isValid={(file) => file?.name === 'UTENTE.KS'}
                  onFileLoaded={(file) => setCertificate3(file)}
                  loadedFile={certificate3}
                  accept={[{ '': ['.ks'] }]} // Stranamente, il file KS non ha un MIME type
                />
              </div>
              <div className="d-flex justify-content-center mt-3">
                <div className="col-6">
                  {/* Password di protezione per il caricamento dei certificati */}
                  {/* Se la password è sbagliata non consente il caricamento dei certificati */}
                  {/* È possibile modificare la password nell'input */}
                  <BwmInput
                    id={`password-modal-${props.id || 0}`}
                    type={'password'}
                    autoComplete="new-password"
                    autocorrect="off"
                    className={'form-control'}
                    label={
                      window > Constants.BREAKPOINT_MD
                        ? `${labels.PASSWORD_PROTECTION}`
                        : `${labels.PASSWORD}`
                    }
                    placeholder={labels.MAX_20_CHARACTERS}
                    maxLength={20}
                    name="password"
                    value={modalSidPassword}
                    onChange={(e) => setModalSidPassword(e.target.value.toUpperCase().trim())}
                    Icon={() => (
                      // Pulsante per mostrare input in modalità testo o password
                      <div
                        className={`d-flex align-self-center`}
                        onClick={(e) => onClickIconPsw(e, `password-modal-${props.id || 0}`)}>
                        <i
                          className={`star-icon bg-primary ${type === 'text' ? 'star-icon-eye' : 'star-icon-eye-off'}`}
                        />
                      </div>
                    )}
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
              {/* Pulsante per chiudere la modale */}
              <button
                className="btn btn-outline-primary"
                onClick={() => setOpenModalLoadCertificates(false)}>
                <i className="star-icon-cancel star-icon me-2" />
                {labels.CANCEL}
              </button>
              {/* Pulsante per confermare il caricamento e far partire la verifica dei certificati */}
              {/* Se non sono rispettate le condizioni viene disabilitato il pulsante */}
              <button
                className="btn btn-primary "
                onClick={() => {
                  onAcceptCertificateModal(
                    certificate1,
                    certificate2,
                    certificate3,
                    modalSidPassword
                  )
                }}
                disabled={
                  Utility.isEmpty(modalSidPassword) ||
                  Utility.isEmpty(certificate1) ||
                  Utility.isEmpty(certificate2)
                }>
                {labels.CONFIRM_AND_VERIFY}
              </button>
            </Modal.Footer>
          </Modal>
        )}
        {/* Modale per configurare i parametri PEC */}
        <ModalPecParameters
          coraSubjectSid={props.coraSubjectSid}
          archived={props.archived}
          show={isPecModalOpen}
          onClose={closePecModal}
          afterSave={(subjectSid) => onSaveMailParameters(subjectSid)}
        />
      </div>
    </div>
  )
}

/**
 * Un componente React che fornisce un'interfaccia di drag and drop per caricare file
 *
 * @param {string} [fileName='UTEC.P12'] il testo da mostrare come etichetta per l'input
 * @param {Array<object<string, string[]>>} [accept=[{ 'application/x-pkcs12': ['.p12'] }]] i tipi di file da accettare
 * @param {function(file: File): boolean} [isValid=(file) => true] una funzione per verificare se il file è valido
 * @param {function(file: File): void} [onFileLoaded=(file) => {}] una funzione da chiamare quando il file viene caricato
 * @param {File} [loadedFile] il file caricato
 */
function DragNDropInputBox({
  fileName = 'UTEC.P12',
  accept = [{ 'application/x-pkcs12': ['.p12'] }],
  isValid = (file) => {
    return true
  },
  onFileLoaded = (file) => {},
  loadedFile
}) {
  const [dragActive, setDragActive] = useState(false)
  const [wrongItem, setWrongItem] = useState(false) //solo per drag e drop
  const [error, setError] = useState(false)
  const filled = Utility.isNotEmpty(loadedFile)
  const lang = useSelector((state) => state.language.language)
  const labels = getText(lang)

  /**
   * Funzione per gestire l'evento drag e drop (trascinamento del file).
   * Se l'evento è di tipo "dragenter" o "dragover", verifica se il tipo di file
   * trascinato è accettato e imposta il flag wrongItem se non lo è.
   * Imposta il flag dragActive a true se l'evento è di tipo "dragenter" o "dragover",
   * false se l'evento è di tipo "dragleave".
   *
   * @param {Event} e l'evento da gestire
   */
  const handleDrag = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setWrongItem(false)
    if (e.type === 'dragenter' || e.type === 'dragover') {
      if (!accept.find((a) => Object.keys(a).some((key) => key === e.dataTransfer.items[0].type))) {
        setWrongItem(true)
      }
      setDragActive(true)
    } else if (e.type === 'dragleave') {
      setDragActive(false)
    }
  }

  /**
   * Gestisce l'evento drop per il trascinamento e rilascio di file.
   * Previeni il comportamento predefinito e interrompe ulteriore propagazione dell'evento.
   * Azzera i flag dragActive e wrongItem a false.
   * Recupera i file rilasciati dall'oggetto dataTransfer dell'evento e li carica usando la funzione onFileLoaded.
   *
   * @param {Event} e - L'evento drop da gestire.
   */
  const handleDrop = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setDragActive(false)
    setWrongItem(false)
    const files = e.dataTransfer.files
    setFiles(files, setError)
  }

  /**
   * Imposta i file da caricare e ne verifica la validità.
   * Se il file è valido, lo carica e imposta l'errore a false.
   * Se il file non è valido, imposta l'errore a true e non carica il file.
   *
   * @param {FileList} files - L'elenco dei file da caricare.
   * @param {Function} errorSetter - La funzione per impostare l'errore.
   */
  const setFiles = (files, errorSetter) => {
    if (files && files.length > 0) {
      const file = files[0]
      if (isValid(file)) {
        onFileLoaded(file)
        Utility.notifySuccess(labels.FILE_UPLOADED_SUCCESSFULLY)
        errorSetter(false)
      } else {
        errorSetter(true)
        onFileLoaded(undefined)
      }
    }
  }

  /**
   * Gestisce l'evento di cambio per l'input del file.
   * Estrae i file dall'oggetto target dell'evento e resetta lo stato di errore.
   * Chiama la funzione setFiles per elaborare i file caricati.
   *
   * @param {Event} e - L'evento triggerato dal cambiamento dell'input del file.
   */
  const handleChange = (e) => {
    const files = e.target.files
    setError(false)
    setFiles(files, setError)
  }

  return (
    <form>
      <input
        type="file"
        id={`fileInput-${fileName}`}
        class="d-none"
        accept={Object.values(accept[0])}
        onChange={handleChange}
      />
      <label
        for={`fileInput-${fileName}`}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
        class={`file-input-label d-flex flex-column pt-1 ${dragActive ? 'drag-active' : ''} ${wrongItem ? 'wrong-item' : ''}`}>
        {wrongItem ? (
          <i className="star-icon-cancel star-icon" style={{ width: '68%', height: '80%' }} />
        ) : (
          <>
            {filled ? (
              <>
                <i className="star-icon-check star-icon" style={{ width: '68%', height: '80%' }} />
                <h5>{fileName}</h5>
              </>
            ) : (
              <>
                <i
                  className="star-icon-upload star-icon"
                  style={{ width: '40%', height: '80%', marginTop: 20 }}
                />
                <h5>Seleziona o trascina</h5>
                <h5>{fileName}</h5>
              </>
            )}
          </>
        )}
      </label>

      {/* Se il caricamento va in errore vengono mostrato il messaggio di errore   */}
      {error && (
        <div className="text-center text-danger font-weight-bold pt-1">
          Inserire file '{fileName}'
        </div>
      )}
    </form>
  )
}

export default SidForm
